import * as types from '../constants/idpAdminActions';
import {clearStorage} from "../actions/storage";

const initialState = {
  errorMsg: null,
  logoutInProgress: false,
};

export default function orgs(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOGOUT_START:
      return {
        ...state,
        errorMsg: null,
        logoutInProgress: true
      };
    case types.LOGOUT_SUCCESS:
      clearStorage();
      return {
        ...state,
        errorMsg: null,
        logoutInProgress: false,
      };
    case types.LOGOUT_FAIL:
      clearStorage();
      return {
        ...state,
        errorMsg: action.errorMsg,
        logoutInProgress: false,
      };
    default:
      return state;
  }
}